import Vue from 'vue'
import store from '@/store'
import {
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_ONOPEN,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
} from '../actions/websocket'

// App specific mutations
import {
  MMCC_HELLO,
  MMCC_TRACE_STARTED,
  MMCC_TRACE_ENDED
} from '@/utils/mmccMessageTypes'

import User from '@/models/User'
import LiveTrace from '@/models/LiveTrace'

// Initial state
const state = () => ({
  isConnected: false,
  message: '',
  error: '',
  reconnectCount: '',
  reconnectError: '',
  channelName: ''
})

// Getters
const getters = {}

// Actions
const actions = {}

// Mutations
const mutations = {
  [SOCKET_ONOPEN]: (state, event) => {
    Vue.prototype.$socket = event.currentTarget
    state.isConnected = true
  },
  [SOCKET_ONCLOSE]: (state) => {
    state.isConnected = false
    state.message = ''
  },
  [SOCKET_ONERROR]: (state) => {
    // Doesn't seem to catch the error.
    state.error = true
  },
  [SOCKET_ONMESSAGE]: (state, message) => {
    state.message = message

    // App specific mutations
    if (message.type === MMCC_HELLO) {
      state.channelName = (message.data.channel_name)
    }
    if (message.type === MMCC_TRACE_STARTED) {
      LiveTrace.insert(message)
    }
    if (message.type === MMCC_TRACE_ENDED) {
      LiveTrace.delete(message.data.trace_id)
    }

  },
  // Mutations for reconnect methods.
  [SOCKET_RECONNECT]: (state, count) => {
    state.reconnectCount = count
  },
  [SOCKET_RECONNECT_ERROR]: (state) => {
    state.reconnectError = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
